// Brandeis's undergraduate majors (#2748). Read on 2026-10-01 from the
// official University Bulletin 2026-2027, Courses of Instruction,
// Undergraduate Majors and Minors (the Undergraduate Majors list; the Minors
// list left out). The list names no degree (B.A. or B.S.), so `degree` is
// null throughout. Brandeis undergraduates all enroll in Arts and Sciences,
// so there is one group. The KB's majors list was the starting point; the
// Bulletin wins.
const majors = {
    "slug": "brandeis-university",
    "read": "2026-10-01",
    "intro": "Every undergraduate major in Brandeis's official 2026-2027 University Bulletin. Brandeis undergraduates all enroll in Arts and Sciences, and the Bulletin's list does not name the degree, so none is shown. Minors and graduate programs are left out.",
    "groups": [
        {
            "name": "Arts and Sciences",
            "source": {
                "label": "Brandeis University Bulletin 2026-2027, Undergraduate Majors and Minors",
                "url": "https://www.brandeis.edu/registrar/bulletin/2026-2027/courses/major-minor.html"
            },
            "majors": [
                {
                    "name": "African and African American Studies",
                    "degree": null
                },
                {
                    "name": "American Studies",
                    "degree": null
                },
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Applied Mathematics",
                    "degree": null
                },
                {
                    "name": "Art History",
                    "degree": null
                },
                {
                    "name": "Biochemistry",
                    "degree": null
                },
                {
                    "name": "Biological Physics",
                    "degree": null
                },
                {
                    "name": "Biology",
                    "degree": null
                },
                {
                    "name": "Business",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Classical and Early Mediterranean Studies",
                    "degree": null
                },
                {
                    "name": "Communication and Media Studies",
                    "degree": null
                },
                {
                    "name": "Comparative Literature and Culture",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Creative Writing",
                    "degree": null
                },
                {
                    "name": "East Asian Studies",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "Education Studies",
                    "degree": null
                },
                {
                    "name": "Engineering Science",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "Environmental Studies",
                    "degree": null
                },
                {
                    "name": "European Cultural Studies",
                    "degree": null
                },
                {
                    "name": "Film, Television and Interactive Media",
                    "degree": null
                },
                {
                    "name": "Finance",
                    "degree": null
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": null
                },
                {
                    "name": "German Studies",
                    "degree": null
                },
                {
                    "name": "Health: Science, Society, and Policy",
                    "degree": null
                },
                {
                    "name": "Hispanic Studies",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "Independent Interdisciplinary Major",
                    "degree": null
                },
                {
                    "name": "International and Global Studies",
                    "degree": null
                },
                {
                    "name": "Latin American, Caribbean, and Latinx Studies",
                    "degree": null
                },
                {
                    "name": "Linguistics",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": null
                },
                {
                    "name": "Near Eastern and Judaic Studies",
                    "degree": null
                },
                {
                    "name": "Neuroscience",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Philosophy, Politics, and Economics",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Politics",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Quantitative Economics",
                    "degree": null
                },
                {
                    "name": "Russian Studies",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Studio Art",
                    "degree": null
                },
                {
                    "name": "Theater Arts",
                    "degree": null
                },
                {
                    "name": "Women's, Gender, and Sexuality Studies",
                    "degree": null
                },
                {
                    "name": "World Literatures",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
